import React from "react";
import { Box, Typography, Grid, Avatar, useTheme, Paper } from "@mui/material";

const FeatureProduct = ({ data, title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 6,
        px: { xs: 2, md: 6 },
        backgroundColor: "#f4f6f8",
      }}
    >
      <Typography
        variant="h4"
        textAlign="center"
        fontWeight="bold"
        color="text.primary"
        gutterBottom
        sx={{ mb: 4 }}
      >
        {title}
      </Typography>

      <Grid container spacing={6} justifyContent="center">
        {/* Left Product Image */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={data.image}
            alt={data.alt || "Product Image"}
            sx={{
              width: "100%",
              height: { xs: "auto", md: 400 },
              objectFit: "cover",
              borderRadius: 4,
              boxShadow: "0 12px 28px rgba(0, 0, 0, 0.15)",
              transition: "transform 0.3s ease-in-out",
              '&:hover': {
                transform: "scale(1.02)",
              },
            }}
          />
        </Grid>

        {/* Right Features Section */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 4,
              overflow: "hidden",
              border: "1px solid #e0e0e0",
              backgroundColor: "#fff",
            }}
          >
            {data.features.map((feature, index) => {
              const IconComponent = feature.icon;

              return (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    px: 3,
                    py: 2.5,
                    borderBottom:
                      index !== data.features.length - 1
                        ? "1px solid #eee"
                        : "none",
                    '&:hover': {
                      backgroundColor: "#f9f9f9",
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "#eaeaea",
                      color: "#000",
                      width: 48,
                      height: 48,
                      mr: 2,
                    }}
                  >
                    <IconComponent />
                  </Avatar>
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      color="text.primary"
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 0.5 }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeatureProduct;
